import { render, staticRenderFns } from "./BookingCapDefaults.vue?vue&type=template&id=7c671a20&lang=pug"
import script from "./BookingCapDefaults.vue?vue&type=script&lang=js"
export * from "./BookingCapDefaults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports